/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_Sales_Range_PromptInputs */

const en_cargos_sales_range_prompt = /** @type {(inputs: Cargos_Sales_Range_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a start and end date to see how many bags were sold in that period.`)
};

const es_cargos_sales_range_prompt = /** @type {(inputs: Cargos_Sales_Range_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige una fecha de inicio y fin para ver cuántos sacos se vendieron en ese período.`)
};

/**
* | output |
* | --- |
* | "Pick a start and end date to see how many bags were sold in that period." |
*
* @param {Cargos_Sales_Range_PromptInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_sales_range_prompt = /** @type {((inputs?: Cargos_Sales_Range_PromptInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_Sales_Range_PromptInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_sales_range_prompt(inputs)
	return es_cargos_sales_range_prompt(inputs)
});